import * as yup from "yup";
import { idMapValidation } from "../schema/commonSchema";
import { Ingredient, BrandName, NDC, Label, ClinicalDrug } from "./basicModels";

ClinicalDrug.relations = [
  /* -------------------------------------------------------------------------- */
  /*                             Outgoing Relations                             */
  /* -------------------------------------------------------------------------- */
  {
    relatedModel: Ingredient,
    name: "HasIngredient",
    displayName: "Has",
    properties: [
      {
        key: "Amount",
        property: "amount",
        validation: yup.string(),
        type: "string",
        default: "",
      },
      {
        key: "Active",
        property: "active",
        validation: yup.string(),
        type: "string",
        default: "",
      },
    ],
    schema: idMapValidation,
  },
  {
    relatedModel: BrandName,
    name: "HasBrandName",
    displayName: "Has",
    properties: [],
    schema: idMapValidation,
  },
  {
    relatedModel: NDC,
    name: "HasNDC",
    displayName: "Has",
    properties: [],
    schema: idMapValidation,
  },
  /* -------------------------------------------------------------------------- */
  /*                             Incoming Relations                             */
  /* -------------------------------------------------------------------------- */
  {
    relatedModel: Label,
    name: "PartOfLabel",
    displayName: "Part Of",
    properties: [],
    schema: idMapValidation,
  },
  /* -------------------------------------------------------------------------- */
  /*                               Self Relations                               */
  /* -------------------------------------------------------------------------- */
];
export const clinicalDrugModel = ClinicalDrug;
